import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useAppSelector } from "../ReduxToolkit/Hooks";
import { innerAuthRoutes } from "./AuthPaths";
import PrivateRouters from "./PrivateRouters";
import RedirectRoute from "./RedirectRoute";
import { routes } from "./Route";
import Error404 from "../Components/Pages/Others/ErrorPage/Error404";
import { lazy, Suspense } from "react";
import Loader from "../Layout/Loader";

const Auth = lazy(() => import("../Auth/Auth"));
const ApplyNow = lazy(() => import("../ApplyNow"));
const Layout = lazy(() => import("../Layout/Layout"));
const UpdatePasswordComponent = lazy(() => import("../Auth/UpdatePassword"));

const Routers = () => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const requiresPasswordUpdate = isAuthenticated && user?.first_login === true;
  const updatePasswordPath = `${process.env.PUBLIC_URL}/update-password`;
  const dashboardPath = `${process.env.PUBLIC_URL}/dashboard`;
  const loginPath = `${process.env.PUBLIC_URL}/sign-in`;
  const ApplyNowPath = `${process.env.PUBLIC_URL}/apply-now`;
  const authenticatedDestination = requiresPasswordUpdate
    ? updatePasswordPath
    : dashboardPath;

  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* 3. UPDATE THE ROOT REDIRECT LOGIC */}
          <Route
            //For Build
            // path={`${process.env.PUBLIC_URL}` || `/`}
            path={`/`}
            element={
              <Navigate
                to={isAuthenticated ? authenticatedDestination : loginPath}
              />
            }
          />

          {/* Protected Routes (Require Layout and RedirectRoute check) */}
          {routes.map((item, index) => (
            <Route element={<Layout />} key={index}>
              <Route
                path={item.path}
                element={<RedirectRoute>{item.element}</RedirectRoute>}
              />
            </Route>
          ))}

          {/* Inner Auth Routes (Require RedirectRoute check) */}
          {innerAuthRoutes.map((item, index) => (
            <Route
              key={index}
              path={item.path}
              element={<RedirectRoute>{item.element}</RedirectRoute>}
            />
          ))}

          {/* 4. ADD THE MANDATORY PASSWORD UPDATE ROUTE */}
          <Route
            path={updatePasswordPath}
            element={
              <Suspense fallback={<Loader />}>
                {/* Do NOT wrap this in RedirectRoute, otherwise it will loop */}
                <UpdatePasswordComponent />
              </Suspense>
            }
          />

          <Route
            path={loginPath}
            element={
              <PrivateRouters>
                <Auth />
              </PrivateRouters>
            }
          />

          {/* 5. APPLY NOW ROUTE */}
          <Route path={ApplyNowPath} element={<ApplyNow />} />

          <Route path={"*"} element={<Error404 />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;
